import { SHOULD_HIDE_BACK_BUTTONS, SHOULD_HIDE_SWITCH_OFFER, SMS_STORE_PEDIDO_VENDA_ID_KEY } from '@/common/constants'
import { getLocalStorage } from '../common/storage'
import { LATEST_CARD_KEY } from './payment/store'
import { DATA_KEY_USER_CARDS, DATA_KEY_INITIAL_VALIDATION } from './user/store'
import { OFFERS, CHANNEL_KEY } from './offers/store'
const PREFIX = 'claro-controle'
const CLIENT_ID = 'client_id'

const store = {
  $storage: getLocalStorage(),
  $prefix: PREFIX,
  $permanent: [],
  $canRemove (key) {
    const isOwner = key.indexOf(this.$prefix) === 0

    if (isOwner) {
      return !this.$permanent.find(k => {
        return this.makeKey(k) === key
      })
    }

    return false
  },
  keep (key) {
    this.$permanent.push(key)
  },
  makeKey (key) {
    return `${this.$prefix}.${key}`
  },
  set (key, value) {
    this.$storage.setItem(
      this.makeKey(key), JSON.stringify(value)
    )

    return Promise.resolve()
  },
  get (key) {
    const data = this.$storage.getItem(this.makeKey(key))

    return Promise.resolve(
      JSON.parse(data)
    )
  },
  clear (force = false, keysToBeCleared) {
    try {
      for (const key in keysToBeCleared || this.$storage) {
        if (force || this.$canRemove(key)) {
          this.$storage.removeItem(key)
        }
      }

      return Promise.resolve()
    } catch (err) {
      return Promise.reject(err)
    }
  },
  clearBut (keysToBeKept) {
    try {
      for (const key in this.$storage) {
        if (!Object.keys(keysToBeKept).includes(key)) {
          this.$storage.removeItem(key)
        }
      }

      return Promise.resolve()
    } catch (err) {
      return Promise.reject(err)
    }
  }
}
const toStorageFormat = (values = []) => {
  return values.reduce((acc, cur) => ({ ...acc, [store.makeKey(cur)]: '' }), {})
}
const clearStorage = (force = false) => store.clear(force)
const clearSelected = (keysToBeCleared) => store.clear(true, keysToBeCleared)
const clearAllBut = (keysToBeKept) => store.clearBut(keysToBeKept)
const forceClearNavigationLock = () => clearSelected(toStorageFormat([SHOULD_HIDE_BACK_BUTTONS, SHOULD_HIDE_SWITCH_OFFER]))
const clearCardData = () => clearSelected(toStorageFormat([LATEST_CARD_KEY, DATA_KEY_USER_CARDS]))

const clearInitial = () => clearAllBut(toStorageFormat([CLIENT_ID, OFFERS, CHANNEL_KEY, SMS_STORE_PEDIDO_VENDA_ID_KEY]))
const clearInitialValidation = () => clearSelected(toStorageFormat([DATA_KEY_INITIAL_VALIDATION]))

export { clearInitial, clearStorage, forceClearNavigationLock, clearCardData, clearInitialValidation }
export default store
